import ElTabs from './src/tabs';

/* istanbul ignore next */
ElTabs.install = function(Vue) {
  Vue.component(ElTabs.name, ElTabs);
};

export default ElTabs;



// WEBPACK FOOTER //
// ./src/components/element/packages/tabs/index.js